import type { DiagnosticReviewDto } from '@malou-io/package-dto';

export class DiagnosticReview {
    author?: string;
    text?: string;
    rating: number;
    language?: string;
    semanticAnalysisSegments: DiagnosticReviewSemanticAnalysisSegment[];

    constructor({ author, text, rating, language, semanticAnalysisSegments }: DiagnosticReview | DiagnosticReviewDto) {
        this.author = author;
        this.text = text;
        this.rating = rating;
        this.language = language;
        this.semanticAnalysisSegments = semanticAnalysisSegments.map(
            (semanticAnalysisSegment) => new DiagnosticReviewSemanticAnalysisSegment(semanticAnalysisSegment)
        );
    }
}

export class DiagnosticReviewSemanticAnalysisSegment {
    category: string;
    segment: string;
    sentiment: string;

    constructor({ category, segment, sentiment }: DiagnosticReviewSemanticAnalysisSegment) {
        this.category = category;
        this.segment = segment;
        this.sentiment = sentiment;
    }
}
